export const GRAMMAR_TYPES = {
  RG: "RG",
  CFG: "CFG",
  CSG: "CSG",
  UG: "UG",
};
